import React from "react";

import {
  BidReportAllAnswers_Result,
  BidReportEntry_Answer_Sources,
} from "lib/generated/app-service-gql/graphql";
import { EventData, EventNames, TrackingProvider } from "lib/tracking";
import { BidReportType } from "lib/types/graphQLEnums";
import { AiContextProvider } from "../../../lib/providers/AiContextProvider";
import { LoadingContent } from "./LoadingContent";
import { QuestionAndAnswer } from "./QuestionAndAnswer";
import ReportCollapse from "./ReportCollapse";

type Props = {
  answerGroup: BidReportAllAnswers_Result;
  bidReportId: string;
  reportType: BidReportType;
  debugMode: boolean;
  onSelectDocument: (
    source: BidReportEntry_Answer_Sources,
    trackingContext: EventNames,
    trackingData: EventData,
  ) => Promise<void>;
  noticeId?: string;
  noticeTitle: string | undefined;
  hasEditAccess: boolean;
  slideoutOpen: boolean;
  isStreaming: boolean | undefined;
  bidId: string | undefined;
  bidName: string;
};
export function BidReportSection({
  answerGroup,
  bidReportId,
  reportType,
  debugMode,
  onSelectDocument,
  slideoutOpen,
  noticeId,
  noticeTitle,
  hasEditAccess,
  isStreaming,
  bidId,
  bidName,
}: Props) {
  const { groupName, questions } = answerGroup;

  const [isOpen, setOpen] = React.useState(false);

  return (
    <AiContextProvider
      context={{
        resourceId: bidId,
        resourceName: bidName,
        resourceType: "REQUIREMENT_SUMMARY",
        bidId,
      }}
    >
      <TrackingProvider
        data={{
          "Criteria name": groupName,
        }}
      >
        <ReportCollapse
          title={groupName}
          open={isOpen}
          onOpenChange={setOpen}
          actions={!isOpen && isStreaming ? <LoadingContent /> : null}
        >
          {questions.map((question, idx) => (
            <QuestionAndAnswer
              question={question}
              key={idx}
              bidReportId={bidReportId}
              reportType={reportType}
              debugMode={debugMode}
              onSelectDocument={onSelectDocument}
              showDivider={groupName === "Strategic fit" && idx < questions.length - 1}
              slideOutOpen={slideoutOpen}
              noticeId={noticeId}
              noticeTitle={noticeTitle}
              hasEditAccess={hasEditAccess}
              hasQuestionRequalify={hasEditAccess}
              isStreaming={isStreaming}
            />
          ))}
        </ReportCollapse>
      </TrackingProvider>
    </AiContextProvider>
  );
}
